(() => {
  const hub = document.querySelector('.cn-maintenance-hub');
  const finder = document.querySelector('[data-cn-care-finder]');
  const openButton = document.querySelector('[data-cn-care-open]');

  if (!hub || !finder || !openButton) return;

  document.body.classList.add('cn-maintenance-hub-active');

  const drawer = document.createElement('div');
  drawer.className = 'cn-care-drawer';
  drawer.hidden = true;
  drawer.innerHTML = `
    <button class="cn-care-drawer__veil" type="button" data-cn-care-close aria-label="Close care planner"></button>
    <aside class="cn-care-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="CnCareDrawerTitle">
      <header class="cn-care-drawer__header">
        <div>
          <p>Guided floor care</p>
          <strong id="CnCareDrawerTitle">Build your care plan.</strong>
        </div>
        <button class="cn-care-drawer__close" type="button" data-cn-care-close aria-label="Close care planner">×</button>
      </header>
      <div class="cn-care-drawer__scroll" data-cn-care-scroll></div>
    </aside>`;

  document.body.appendChild(drawer);
  drawer.querySelector('[data-cn-care-scroll]').appendChild(finder);

  const groups = Array.from(finder.querySelectorAll('.cn-care-finder__group'));
  const result = finder.querySelector('[data-cn-care-result]');
  const tool = finder.querySelector('.cn-care-finder__tool');
  let currentStep = 0;
  let returnFocus = null;

  const stepper = document.createElement('div');
  stepper.className = 'cn-care-stepper';
  stepper.innerHTML = `
    <span class="cn-care-stepper__label" data-cn-care-step-label></span>
    <span class="cn-care-stepper__track"><span data-cn-care-step-progress></span></span>
    <button class="cn-care-stepper__back" type="button" data-cn-care-back>Back</button>`;
  tool.prepend(stepper);

  const label = stepper.querySelector('[data-cn-care-step-label]');
  const progress = stepper.querySelector('[data-cn-care-step-progress]');
  const back = stepper.querySelector('[data-cn-care-back]');

  const renderStep = () => {
    groups.forEach((group, index) => group.classList.toggle('is-active', index === currentStep));
    if (result) result.classList.remove('is-active-result');
    label.textContent = `Step ${currentStep + 1} of ${groups.length}`;
    progress.style.width = `${((currentStep + 1) / groups.length) * 100}%`;
    back.disabled = currentStep === 0;
    drawer.querySelector('[data-cn-care-scroll]').scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openDrawer = () => {
    returnFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('cn-care-drawer-open');
    openButton.setAttribute('aria-expanded', 'true');
    drawer.querySelector('[data-cn-care-close]').focus();
    renderStep();
  };

  const closeDrawer = () => {
    drawer.hidden = true;
    document.body.classList.remove('cn-care-drawer-open');
    openButton.setAttribute('aria-expanded', 'false');
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
  };

  openButton.addEventListener('click', openDrawer);
  drawer.querySelectorAll('[data-cn-care-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  back.addEventListener('click', () => {
    if (currentStep > 0) {
      currentStep -= 1;
      renderStep();
    }
  });

  finder.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-cn-care-surface], [data-cn-care-finish], [data-cn-care-need], [data-cn-care-site], [data-cn-care-instructions]');
    if (!choice) return;

    window.setTimeout(() => {
      if (currentStep < groups.length - 1) {
        currentStep += 1;
        renderStep();
        return;
      }

      groups.forEach((group) => group.classList.remove('is-active'));
      label.textContent = 'Your care plan';
      progress.style.width = '100%';
      back.disabled = false;
      if (result && !result.hidden) {
        result.classList.add('is-active-result');
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 180);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  renderStep();
})();
